<script setup lang="ts">
import { ButtonV2, HugeIcon } from '@teachino/shared-design-system';
import { $t } from '@teachino/shared-i18n';
import {
  type UpgradeSource,
  useGlobalDependencyProvider,
} from '@teachino/shared-util';
import { ref } from 'vue';
import { useLicense } from './useLicense';

const LOADING_ICON_SIZE = 20;

const props = defineProps<{
  source: UpgradeSource;
}>();

const { openProLicenseCheckout } = useLicense();
const di = useGlobalDependencyProvider();
const analytics = di.inject('analytics');
const isTraineeUpgradeLoading = ref(false);
const config = di.inject('config');

const buyTrainee = async (years: 'two' | 'one'): Promise<void> => {
  isTraineeUpgradeLoading.value = true;
  analytics.track('upgrade-start-payment', { source: props.source });
  await openProLicenseCheckout({
    discountId:
      years === 'one'
        ? config.traineeDiscountCode()
        : config.traineeDiscountCode2Year(),
    billingCycle: years === 'one' ? 'YEARLY' : 'TWO_YEARS',
  });
  isTraineeUpgradeLoading.value = false;
};
</script>

<template>
  <div class="grid min-h-8 w-full place-items-center">
    <div
      v-if="!isTraineeUpgradeLoading"
      class="flex w-full max-w-md flex-col gap-2 sm:max-w-none sm:flex-row sm:items-center sm:justify-center"
    >
      <ButtonV2
        class="w-full justify-center sm:w-auto"
        variant="secondary"
        size="sm"
        :label="$t('upgrade.buy.trainee.cta_two_years')"
        @click="void buyTrainee('two')"
      />
      <ButtonV2
        class="w-full justify-center sm:w-auto"
        variant="secondary"
        size="sm"
        :label="$t('upgrade.buy.trainee.cta_one_year')"
        @click="void buyTrainee('one')"
      />
    </div>
    <HugeIcon
      v-else
      icon="loading"
      :spin="true"
      :size="LOADING_ICON_SIZE"
      class="text-primary-500"
      aria-busy="true"
    />
  </div>
</template>
